import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=7b5592cc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5592cc')) {
      api.createRecord('7b5592cc', component.options)
    } else {
      api.reload('7b5592cc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=7b5592cc&", function () {
      api.rerender('7b5592cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iV9oQSJm7xxI/JS/comp/FavElement.vue"
export default component.exports